import { apiConfig } from 'core-lib/config/config';
import { CartItem } from '../../types/cart';
import { postMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';
import { serializeCart } from './getCart';

const buyNowItem = async (item: CartItem, cartId: string) => {
  const endPoint = `${apiConfig(
    'magento'
  )}/default/V1/carts/mine/items/custom/buyNow`;
  const cartItem: any = {
    qty: item.quantity,
    quote_id: `${cartId}`,
    sku: item.productSku,
  };
  if (item?.productOption) {
    cartItem.product_option = item.productOption;
  }
  const body: any = {
    cart_item: cartItem,
  };
  const { response, error }: any = await postMethod({
    endPoint,
    body,
    headers: getDefaultHeaders({ deviceId: true }),
    enableErrorHandling: true,
  });
  if (response?.data) {
    return serializeCart(response.data);
  }

  return null;
};

export default buyNowItem;
